export default "__VITE_ASSET__DAxvTWzX__"